module.exports = __webpack_public_path__ + "img/high flyer gym.c3ad5f70.jpg";